import React from "react";
import { Link } from "react-router-dom";

const Navbar: React.FC = () => {
  return (
    <nav
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 30px",
        backgroundColor: "#fff",
        borderBottom: "1px solid #ddd",
      }}
    >
      {/* Left: Logo + Home */}
      <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <div style={{ fontWeight: "bold", fontSize: "18px" }}>
          Mark's Travel Memories
        </div>
        <Link to="/" style={{ textDecoration: "none", color: "#333" }}>
          Home
        </Link>
      </div>

      {/* Right side is now empty — removed global MusicPlayer */}
    </nav>
  );
};

export default Navbar;